import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-71d78f8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-5\" data-v-71d78f8c><div class=\"col-12 text-center\" data-v-71d78f8c><p class=\"section-subtitle\" data-v-71d78f8c> L’Equipe d’Animateurs et Animatrices assure la formation chrétienne sur les paroisses et dans les groupes et associations, à travers conférences ou récollections et présence sur les réseaux sociaux. Elle est constituée de disciples d’Emmaüs ayant régulièrement suivi avec succès au moins un parcours de 2 ans à l’EITP et désireux de partager la formation reçue avec leurs frères et sœurs. </p></div></div><div class=\"row justify-content-center mb-5\" data-v-71d78f8c><div class=\"col-lg-8\" data-v-71d78f8c><div class=\"tutor-card\" data-v-71d78f8c><h3 class=\"tutor-section-title\" data-v-71d78f8c>Rôle et mission</h3><ul class=\"tutor-list\" data-v-71d78f8c><li data-v-71d78f8c>Assurer la formation chrétienne sur les paroisses et au sein des groupes et associations.</li><li data-v-71d78f8c>Organiser et animer des conférences, récollections et autres activités spirituelles.</li><li data-v-71d78f8c>Être présents sur les réseaux sociaux pour partager des contenus de formation et renforcer la cohésion.</li><li data-v-71d78f8c>Transmettre les valeurs et l’esprit du parcours EITP aux disciples et nouveaux participants.</li></ul></div></div></div>", 2)
const _hoisted_5 = { class: "row g-4 mt-3" }
const _hoisted_6 = { class: "prof-mini-card" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "prof-mini-name" }
const _hoisted_10 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.etudiants, (etu) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-3 col-lg-3 col-md-4 col-sm-6",
            key: etu.id
          }, [
            _createElementVNode("div", _hoisted_6, [
              (etu.user?.urlImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.getImageUrl(etu.user.urlImage),
                    alt: "Photo disciple",
                    class: "prof-photo"
                  }, null, 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.defaultPhoto,
                    alt: "Photo par défaut",
                    class: "prof-photo"
                  }, null, 8, _hoisted_8)),
              _createElementVNode("h5", _hoisted_9, [
                _createVNode(_component_router_link, {
                  to: `/disciplesEmmaius/${etu.id}`,
                  class: "prof-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(etu.nom) + " " + _toDisplayString(etu.prenom), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}